import Markdown from 'markdown-to-jsx';
import clsx from 'clsx';
import { useMarkdownContents, Props } from './useMarkdownContents';
import styles from './MarkdownContents.module.css';

export const MarkdownContents = (props: Props) => {
  const { markdown } = useMarkdownContents(props);

  return (
    <div className={clsx(styles.markdown, 'prose')}>
      <Markdown>{markdown}</Markdown>
    </div>);

};